import { Container, Box } from "@mui/material";
import { giveMeImage } from "../../data/data";

const GiftCardWorking = () => {
    return (
        <Container
            maxWidth="false"
            disableGutters={true}
            sx={{
                backgroundColor: "primary.main",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
            }}
        >
            <Box maxWidth="lg"
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",

                }}
            >
                <Box
                    component="img"
                    src={giveMeImage('how_gift_cards_work')?.image}
                    alt="How Gift Card Works image"
                    loading="lazy"
                    sx={{
                        width: "100%",
                        height: {
                            xs: "100%",
                        },
                        borderRadius: {
                            xs: 2,
                            md: 0,
                        },
                    }}
                />
            </Box>
        </Container>
    );
};

export default GiftCardWorking;
